module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-500@2x_15bea2.jpg";